module.exports = __webpack_public_path__ + "static/media/education.50e3d0ae.svg";